export const NO_DATA_MATCH = ["No matching data"];
